// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3oMQA","footer":"Form_footer__2Et-l"};